import moment from "moment";
import { DATE_FORMATS } from "../../../constants";
import {
  ApplicationStatus,
  IStudentApplicationCardFrontEndModel,
} from "../types";

export function orderApplicationsByStatus(
  applications: IStudentApplicationCardFrontEndModel[],
) {
  const sortedBySubmissionDate = applications.sort(
    (a, b) =>
      moment(b.submissionDate, DATE_FORMATS.frontEnd).unix() -
      moment(a.submissionDate, DATE_FORMATS.frontEnd).unix(),
  );

  return sortedBySubmissionDate.sort((a, b) => {
    let scoreA;
    let scoreB;

    if (a.status.type === ApplicationStatus.APPROVED) {
      scoreA = 1;
    }

    if (b.status.type === ApplicationStatus.APPROVED) {
      scoreB = 1;
    }

    if (a.status.type === ApplicationStatus.PENDING) {
      scoreA = 2;
    }

    if (b.status.type === ApplicationStatus.PENDING) {
      scoreB = 2;
    }

    if (a.status.type === ApplicationStatus.REJECTED) {
      scoreA = 3;
    }

    if (b.status.type === ApplicationStatus.REJECTED) {
      scoreB = 3;
    }

    if (
      a.schoolCancellationNote ||
      a.studentCancellationNote ||
      moment(a.startDate, DATE_FORMATS.frontEnd).isBefore(moment())
    ) {
      scoreA = 4;
    }

    if (
      b.schoolCancellationNote ||
      b.studentCancellationNote ||
      moment(b.startDate, DATE_FORMATS.frontEnd).isBefore(moment())
    ) {
      scoreB = 4;
    }

    return scoreA - scoreB;
  });
}
